import { Component, ViewEncapsulation, inject } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { ButtonComponent } from '../../../../../shared/components/button/button.component';
import { NoRecordsComponent } from '../../../../../shared/components/no-records/no-records.component';
import { RideStatusType } from '../../../../../shared/enums/rideStatusType';
import { WaypointActivityLog } from '../../../../../shared/interfaces/waypoint-activity-log';
import { RequestBuilderService } from '../../../../../shared/services/request-builder.service';
import { changeTime } from '../../../../../shared/utilities/utility-functions';
import { AccordionModule } from 'primeng/accordion';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { TextareaModule } from 'primeng/textarea';
import { MenuModule } from 'primeng/menu';
import { BasicTableComponent } from '../../basic-table/basic-table.component';
import { UserRole } from '../../../../../core/auth/enums/userRoles';
@Component({
  selector: 'app-waypoints-activity-log-dialog',
  standalone: true,
  imports: [FormsModule, ButtonComponent, TextareaModule, BasicTableComponent, AccordionModule, MenuModule, NoRecordsComponent],
  templateUrl: './waypoints-activity-log-dialog.component.html',
  styleUrl: './waypoints-activity-log-dialog.component.scss',
  encapsulation: ViewEncapsulation.None,
})
export class WaypointsActivityLogDialogComponent {
  ref = inject(DynamicDialogRef);
  config = inject(DynamicDialogConfig);
  private readonly requestBuilder = inject(RequestBuilderService);

  rideId = 0;
  order = 1;
  isClient = (localStorage.getItem('role') ?? '').toLowerCase() === UserRole.Client;
  activityLogTableData: { columns: any[]; data: any[] } = {
    columns: [
      { name: 'id', displayName: '#' },
      { name: 'actionType', displayName: 'Action' },
      { name: 'Passenger', displayName: 'Passenger' },
      { name: 'createdBy', displayName: 'Done by' },
      { name: 'doneAtUtc', displayName: 'Done At' },
      { name: 'doneAtAddress', displayName: 'Done at Address' },
      { name: 'distanceFromAddress', displayName: 'Distance from Address' },
      { name: 'internalNote', displayName: 'Internal Note' },
      { name: 'driverNote', displayName: 'Driver Note' },
    ],
    data: [],
  };
  constructor() {
    this.rideId = this.config.data.originalRideId;
    this.order = this.config.data.rideTimeline.findIndex((item: any) => item.stopId === this.config.data.stopId) + 1;
    this.getRideActivityLog();
  }

  addPassengerDataToRide(waypoint: any): any {
    let passengerName = '-';
    if (waypoint.stopCargoId) {
      const stop = this.config.data.rideTimeline.find((item: any) => item.stopId === waypoint.stopId);
      passengerName = stop?.cargoes ? stop.cargoes.find((b: any) => b.stopCargoId === waypoint.stopCargoId)?.name : '';
    }

    const updatedObject = {
      ...waypoint,
      doneAtUtc: waypoint.doneAtUtc ? changeTime(waypoint.doneAtUtc + 'z', 'MM/DD/YYYY hh:mm A', this.config.data.timezoneOffsetInSeconds) : waypoint.doneAtUtc,
      doneAtAddress: waypoint.doneAtAddress ?? '-',
      distanceFromAddress: waypoint.distanceFromAddress ? `${waypoint.distanceFromAddress?.toFixed(2)} Miles` : waypoint.distanceFromAddress,
      Passenger: passengerName,
    };

    if (this.hasAttention(waypoint)) {
      updatedObject['attentionDescription'] = this.hasAttention(waypoint);
    }

    return updatedObject;
  }

  getRideActivityLog() {
    this.requestBuilder.get(`rides/stops/${this.config.data.stopId}/activity-logs`).subscribe({
      next: res => {
        console.log(res);
        this.activityLogTableData.data = res.data.map(this.addPassengerDataToRide.bind(this)) ?? [];
      },
      error: error => {},
    });
  }

  private hasAttention(stop: WaypointActivityLog): string {
    let attentionDescription = '';
    const checkNoShowAttentions = () => {
      //No-show attentions :-
      //1- No Show submitted before waiting 5 minutes.
      //2- Driver submitted no-show at Wrong Location.
      if (stop.actionType?.includes('Status - No-show')) {
        if (stop.rideStatusId == RideStatusType.NoShow && stop.cargoActionType == 'Pick-up' && stop.stopQualityScoreItems?.includes('The Driver was no-show passenger before 5 minutes from STA')) {
          attentionDescription = 'No Show submitted before waiting 5 minutes.';
        }
        if (stop.stopQualityScoreItems?.includes('The Driver was arrived at wrong location') && stop.distanceFromAddress && stop.distanceFromAddress >= 0.15) {
          attentionDescription = 'Driver submitted no-show at Wrong Location';
        }
      }
    };

    const checkArrivedAttentions = () => {
      //Arrived attentions:-
      //1- Driver has arrived early before X minutes from STA.
      //2- Driver Arrived at Wrong Location.
      if (stop.actionType?.includes('Status - Arrived')) {
        if (stop.earlyArrivalInMinutes > 5) {
          attentionDescription = 'Driver has arrived early before ' + stop.earlyArrivalInMinutes + ' minutes from STA.';
        }
        if (stop.stopQualityScoreItems?.includes('The Driver was arrived at wrong location') && stop.distanceFromAddress && stop.distanceFromAddress >= 0.15) {
          attentionDescription = 'Driver Arrived at Wrong Location';
        }
      }
    };

    const checkCancellationAttentions = () => {
      //Cancelation attentios:-
      //1- Early Cancel/Late cancel was set in a time that is not within allowed time gap.
      if (stop.actionType == 'Update Ride Waypoint Status - Canceled in Advance' || stop.actionType == 'Update Ride Waypoint Status - Canceled Late') {
        if (stop.isWrongCancelation) {
          attentionDescription = 'Early Cancel/Late cancel was set in a time that is not within allowed time gap.';
        }
      }
    };

    checkNoShowAttentions();
    checkArrivedAttentions();
    checkCancellationAttentions();

    return attentionDescription;
  }
}
